export const DEFAULT_CONFIG = {
  warehouses: ["Jaipur", "Ahmedabad", "Bhiwandi", "New Delhi", "Hyderabad"],
  warehouse_staff: [
    "Govind", "Prashant", "Rohit", "Pramesh", "Deepak", "Ankit", "Deepankar", "Pranav Maachi"
  ],
  transporters: [
    "#PORT", "#WHEELS-EYE", "#WINS", "#J&K TRP", "#OLA", "#HEMANT", "#ORANGE CARGO", "#SONU", "#VISHNU", 
    "#JAIN TRP", "#KABRA EXP", "#SELF", "#TCI", "#FASTWAY", "#RIVIGO", "#RK TRP AHM", "#TRACKON", 
    "#MARUTI", "#DELHIVERY", "#Anjani courier services", "#Hemant logistics", "#courier"
  ],
  vehicle_types: [
    "TATA ACE", "3 WHEELER", "TATA 407", "PICKUP -8 FEET", "PICKUP - 9 FEET",
    "TRUCK - 14 FEET", "TRUCK - 19 FEET", "TRUCK - 20 FEET", "TRUCK - 32 FEET",
    "TRUCK - 40 FEET", "PART LOAD", "COURIER", "SELF PICKUP", "2 Wheeler"
  ],
  moc_types: [
    "Sales", "Rental", "Interbranch Transfer", "Repair", "Demo/Exhibition", "Scrap"
  ],
  moc_prepared_by: [
    "Ankit Kumar", "Ghanshyam Prajapat", "Rajesh Kumar", "Dipankar Dhar"
  ],
  moc_verified_by: [
    "Ghanshyam Prajapat", "Rajesh Kumar", "Rajesh Soni"
  ],
  qc_verified_by: [
    "GOVIND", "PRASHANT", "ROHIT", "SHRIKANT", "PARMESH", "DEEPAK", "ANKIT", "DEEPANKAR", "PRANAV MAACHI", "DEEPAK KUMAR"
  ],
  delivery_confirmed_by: [
    "GOVIND", "PRASHANT", "ROHIT", "SHRIKANT", "PARMESH", "DEEPAK", "ANKIT", "GHANSHYAM", "RAJESH KUMAR", "DEEPANKAR", "PRANAV MAACHI", "DEEPAK KUMAR"
  ],
  finance_verified_by: [
    "Jasveer Singh", "Tikkam Chand", "Saurabh Ganeriwal"
  ],
  sales_team: [
    "Rajesh Soni", "Sanjay Kumawat", "Deepak Yadav", "Deepak Kumar", 
    "Rohit Soni", "Prinka Sharma", "Ankit Kumar Jangid", "Piyush Agarwal", "Pranav Machhi"
  ]
};
